import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseListComponent } from 'src/modules/sm-base/components/admin-base-list/admin-base-list.component';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { Objects } from "src/modules/utils/shared/objects";
import { ProjectPlanningTools } from "../../models/project-planning-tools.model";
import { ProjectTemplate } from '../../netgen/ProjectTemplate';
import { ProjectType } from '../../netgen/ProjectType';
import { ProjectPlanningService } from '../../services/project-planning.service';

@Component({
    selector: 'app-edit-project-templates',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditProjectTemplatesComponent extends AdminBaseListComponent<ProjectTemplate> {

    service = inject(ProjectPlanningService);
    
    definition = ProjectPlanningTools.definitionProjectTemplate;

    projectTypes: ProjectType[];
        
    getTable(): TableData {
        return this.app.tTable("entity.ProjectTemplate.fields", new TableData([
            new TableColumn("title", "", TableCellType.string, 50),
            new TableColumn("projectType", this.app.t("entity.ProjectTemplate.fields.typeId"), TableCellType.string, 30)
        ], this.listData.map(o => new TableRow(Objects.toString(o.id), o, {
            title: o.title,
            projectType: this.service.getProjectType(o.typeId)?.title ?? ""
        })), ["title"]));
    }

    async initAdditionalData(): Promise<void> {
        await this.service.getProjectTypes();
    }
}
